import styled from 'styled-components'

const FamaleTierWrapper = styled.div`
    cursor: pointer
`

const QuestionContent = styled.div`
    position: absolute;
    background: #FFF;
    color: #414141;
    padding: 10px 15px;
    top: 50px;
    z-index: 9;
    border-radius: 4px;
    font-size: 0.9rem;
    left: calc(50% - 125px);
    width: 280px;
    text-align: left;
    box-shadow: 0px 0px 4px #b4b4b4;
    display: none;
    &:before {
        content: " ";
        width: 0;
        height: 0;
        border-left: 11px solid transparent;
        border-right: 11px solid transparent;
        border-bottom: 11px solid #b4b4b4;
        position: absolute;
        top: -11px;
        left: calc(50% - 24px);
    }
    &:after {
        content: " ";
        width: 0;
        height: 0;
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        border-bottom: 10px solid #FFF;
        position: absolute;
        top: -10px;
        left: calc(50% - 23px);
    }
    p {
        font-weight: normal;
        margin-bottom: 0px;
        line-height: 1.5;
        text-align: center;
    }
`

const Question = styled.span`
    position: relative;
    cursor: pointer;
    margin-left: 10px;
    svg {
        color: #f84f7f;
    }
    &:hover {
        ${QuestionContent}{
            display: block;
        }
    }
`

const Bonus = styled.div`
    margin-left: 15px;
    margin-bottom: 15px;
    background: #f84f7f;
    display: inline-block;
    color: #FFF;
    padding: 3px 10px;
    border-radius: 5px;
    cursor: pointer;
    font-size: 0.7rem;
`

const AccountStatus = styled.div`
    padding: 15px;
`

const AccountStatusTitle = styled.div`
    font-weight: 650;
`

const AccountStatusItem = styled.div`
    font-size: 14px;
    margin: 2px 5px;
    color: #bd0606;
`

const AccountStatusCount = styled.div`
    font-size: 14px;
`
const AccountStatusWarning = styled.div`
    font-size: 14px;
    color: #6a6a6a;
`
const DownloadAndroid = styled.img`
    height: 50px;
`

const DownloadIos = styled.img`
    height: 50px;
    margin-right: 15px;
`

const DownloadContainer = styled.div`
    display: flex;
    justify-content: center;
    margin-top: 10px;
`

const FeeDescription = styled.div`
    font-size: 12px;
    margin-top: 10px;
    color: #6a6868;
`

const StoryContainer = styled.div`
    text-align: center;
    margin-top: 10px;
`

const StoryAction = styled.button`
    color: #FFF;
    display: inline-block;
    background: #f84f7f;
    padding: 6px 15px;
    border-radius: 5px;
    border: 1px solid #f84f7f;
    &:hover {
        opacity: 0.6;
    }
`

const Text = styled.div`
    font-size: 14px;
    margin-bottom: 20px;
    font-weight: 500;
`

const FemaleBox = styled.div`
    @media (max-width: 767px) {
        display: none;
    }
`

export {
    FamaleTierWrapper,
    QuestionContent,
    Question,
    Bonus,
    AccountStatus,
    AccountStatusTitle,
    AccountStatusCount,
    AccountStatusWarning,
    AccountStatusItem,
    DownloadAndroid,
    DownloadIos,
    DownloadContainer,
    FeeDescription,
    StoryAction,
    StoryContainer,
    Text, FemaleBox
}